(function () {
  const CLOSE_DELAY = 150;

  let closeTimer = null;

  function openItem(item) {
    clearTimeout(closeTimer);
    // Close any other open items first
    document.querySelectorAll('.nn-nav__item--open').forEach(function (open) {
      if (open !== item) closeItem(open, true);
    });
    item.classList.add('nn-nav__item--open');
    const trigger = item.querySelector('[data-nav-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closeItem(item, immediate) {
    clearTimeout(closeTimer);
    if (immediate) {
      item.classList.remove('nn-nav__item--open');
      const trigger = item.querySelector('[data-nav-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    } else {
      closeTimer = setTimeout(function () {
        item.classList.remove('nn-nav__item--open');
        const trigger = item.querySelector('[data-nav-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }, CLOSE_DELAY);
    }
  }

  function init() {
    const items = document.querySelectorAll('.nn-nav__item');

    items.forEach(function (item) {
      // Open on pointer enter
      item.addEventListener('pointerenter', function () {
        if (item.querySelector('.nn-dropdown-wrap')) {
          openItem(item);
        }
      });

      // Start close timer on pointer leave
      item.addEventListener('pointerleave', function () {
        closeItem(item, false);
      });

      // Cancel close if pointer enters the dropdown
      const dropdown = item.querySelector('.nn-dropdown-wrap');
      if (dropdown) {
        dropdown.addEventListener('pointerenter', function () {
          clearTimeout(closeTimer);
        });
        dropdown.addEventListener('pointerleave', function () {
          closeItem(item, false);
        });
      }
    });

    // Close everything if clicking outside
    document.addEventListener('pointerdown', function (e) {
      if (!e.target.closest('.nn-nav__item')) {
        document.querySelectorAll('.nn-nav__item--open').forEach(function (item) {
          closeItem(item, true);
        });
      }
    });

    // Keyboard: close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.nn-nav__item--open').forEach(function (item) {
          closeItem(item, true);
        });
      }
    });
  }

  // Wait for DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();